<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="room/admin/item_type/additional_item/"
                       :extra-params="{type_id: itemTypeId}"
                       data-key="additional_items"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.actions="{item}">
      <v-menu offset-y
              rounded
              left>
        <template v-slot:activator="{on}">
          <v-btn icon
                 v-on="on">
            <v-icon>fas fa-cog</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-2">
          <v-list-item @click="editItem(item)">
            <v-icon>fas fa-search</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('detail') }}</label>
          </v-list-item>
          <v-list-item @click="deleteItem(item)">
            <v-icon>fas fa-trash</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('delete') }}</label>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'ItemTypeAdditionalItemList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    itemTypeId: String,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        // {text: root.$t('admin_acc_location.name_en'), value: 'name_en', contains: true},
        // {text: root.$t('admin_acc_location.name_zh'), value: 'name_zh', contains: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_item_type_additional_item.name_en'), value: 'name_en'},
      {text: root.$t('admin_acc_item_type_additional_item.name_zh'), value: 'name_zh'},
      {text: root.$t('admin_acc_item_type_additional_item.price'), value: 'price'},
      {text: '', value: 'actions'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };
    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_price_tier.confirm_delete'))) {
        root.$callAPI('room/admin/item_type/additional_item/delete/', {
          additional_item_id: item.id,
        }, function (response) {
          refresh();
        });
      }
    };


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteItem,
    }
  }
}
</script>
